import { Children, cloneElement, isValidElement, ReactNode } from "react";
import PerfilMenu from "./ui/PerfilMenu";
interface ChildProps {
    chave_empreender: string;
}

const PerfilWrapper = ({ children }: { children: ReactNode }) => {

    const perfilMenu = Children.map(children, (child) => {
        if (isValidElement(child) && child.type === PerfilMenu) {
            return cloneElement(child, {} as ChildProps);
        }
        return null;
    });

    return <>
        {perfilMenu}
    </>
};

export default PerfilWrapper;